import React, {useEffect} from "react";
const SearchLoading = () => {
  return (
    <>
      <div className="ol_d_cb set_loading_cb activeFormCon spacerCB_loading loadingData"
              style={{ height: "100%"}}>
              <div className="loader_cb">
                <div className="loading_text_data">
                  Please wait! We are getting available resources for you.
                </div>
                <div className="loading-spinner"></div>
              </div>
            </div>
    </>
  );
};

export default SearchLoading;
